import { t as e } from "./createLucideIcon-CJLgHpqc.js";
var t = e("chevron-down", [["path", {
	d: "m6 9 6 6 6-6",
	key: "qrunsl"
}]]);
//#endregion
export { t };

//# sourceMappingURL=chevron-down-D8vOGVnQ.js.map